import { Injectable } from '@angular/core';

export const ALL_LOCAL_STORAGE_KEYS = [
  'appId',
  'route',
  'urlAssets',
  'userCountry',
  'environment',
  'npe',
  'adminModule',
  'personType',
  'accountId',
] as const;

export type LocalStorageKey = (typeof ALL_LOCAL_STORAGE_KEYS)[number];

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  setItem(key: LocalStorageKey, value: string) {
    localStorage.setItem(key, value);
  }

  getItem(key: LocalStorageKey) {
    return localStorage.getItem(key);
  }

  removeItem(key: LocalStorageKey) {
    localStorage.removeItem(key);
  }

  getAllItems(): Record<LocalStorageKey, string | null> {
    const allItems: Partial<Record<LocalStorageKey, string | null>> = {};

    for (const key of ALL_LOCAL_STORAGE_KEYS) {
      allItems[key] = localStorage.getItem(key);
    }

    return allItems as Record<LocalStorageKey, string | null>;
  }

  clear() {
    localStorage.clear();
  }
}
